/* =====================================================================
   THE SWEATY GAMBESON — theme behaviour
   Drawers/overlays · rotating announcement · size-chart tabs ·
   Shopify Ajax cart · predictive search.
   ===================================================================== */
(function () {
  'use strict';

  var body = document.body;
  var root = document.documentElement;

  /* ---------- money ---------- */
  var MONEY_FORMAT = body.getAttribute('data-money-format') || '${{amount}}';
  function formatMoney(cents, format) {
    format = format || MONEY_FORMAT;
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    switch ((format.match(placeholder) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = defaultTo(cents, 2, "'", '.'); break;
      default: value = defaultTo(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- tiny helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function scrim() { return $('[data-scrim]'); }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  /* ---------- open / close ---------- */
  function lockScroll(on) { root.style.overflow = on ? 'hidden' : ''; }
  function openEl(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim()) scrim().classList.add('open');
    lockScroll(true);
  }
  function openCart() { refreshCart(); openEl('cart-drawer'); }
  function openSearch() {
    openEl('search-overlay');
    var i = $('[data-search-input]');
    if (i) { runPredictive(''); setTimeout(function () { i.focus(); }, 120); }
  }
  function openMobile() { openEl('mobile-nav'); }
  function openSize() { openEl('size-modal'); }
  function closeAll() {
    $all('.drawer, .search-overlay, .mobile-nav, .size-modal').forEach(function (e) {
      e.classList.remove('open');
      e.setAttribute('aria-hidden', 'true');
    });
    if (scrim()) scrim().classList.remove('open');
    lockScroll(false);
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }
  function flashCount() {
    $all('[data-cart-count]').forEach(function (el) {
      if (el.animate) el.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }],
        { duration: 340 });
    });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    var bodyEl = $('[data-cart-body]');
    var footEl = $('[data-cart-foot]');
    if (!bodyEl || !footEl) return;

    if (!cart.item_count) {
      bodyEl.innerHTML =
        '<div class="cart-empty">' +
          '<img src="' + (window.TSG_EMPTY_IMG || '') + '" alt="">' +
          '<p style="font-style:italic;font-size:20px;margin:0 0 18px">Thy satchel is empty.<br>A tragedy. Remedy it.</p>' +
          '<a class="btn btn--ghost" href="' + (window.TSG_ALL_URL || '/collections/all') + '" data-close>To the Shoppe</a>' +
        '</div>';
      footEl.innerHTML = '';
      return;
    }

    bodyEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_144x$1') + '" alt="">' : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="variant">' + item.variant_title + '</div>' : '';
      return '' +
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<a class="thumb" href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<h4>' + item.product_title + '</h4>' + variant +
            '<div class="qty">' +
              '<button data-qty-down aria-label="Decrease">−</button>' +
              '<input data-qty-input type="text" inputmode="numeric" value="' + item.quantity + '" aria-label="Quantity">' +
              '<button data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right">' +
            '<div class="line-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button class="cart-remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');

    var enabled = body.getAttribute('data-free-patch-enabled') === 'true';
    var threshold = parseInt(body.getAttribute('data-free-patch-threshold'), 10) || 0;
    var shipNote = '';
    if (enabled && threshold > 0) {
      var remain = threshold - cart.total_price;
      shipNote = remain > 0
        ? '<p class="ship-note">Add <b>' + formatMoney(remain) + '</b> more for a free crest patch.</p>'
        : '<p class="ship-note">You’ve earned a <b>free crest patch</b>. Honour!</p>';
    }
    footEl.innerHTML =
      shipNote +
      '<div class="row"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<div class="row total"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<button class="btn btn--rust btn--block btn--lg" data-checkout>Ride to Checkout</button>' +
      '<p style="text-align:center;font-style:italic;color:var(--steel-2);font-size:13px;margin:12px 0 0">Taxes &amp; shipping reckoned at the gate.</p>';
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    var bodyEl = $('[data-cart-body]');
    if (bodyEl) bodyEl.classList.add('cart-loading');
    return postJSON('/cart/change.js', { id: key, quantity: quantity })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return refreshCart(); })
      .finally(function () { if (bodyEl) bodyEl.classList.remove('cart-loading'); });
  }

  function addItem(id, quantity, onDone) {
    return postJSON('/cart/add.js', { items: [{ id: id, quantity: quantity || 1 }] })
      .then(function (res) {
        if (res.status) { // error object
          if (onDone) onDone(res);
          return res;
        }
        return refreshCart().then(function (cart) {
          flashCount();
          openCart();
          if (onDone) onDone(null, cart);
          return cart;
        });
      });
  }

  /* ---------- predictive search ---------- */
  var searchTimer;
  function runPredictive(q) {
    var wrap = $('[data-search-results]');
    if (!wrap) return;
    q = (q || '').trim();
    if (!q) {
      wrap.innerHTML = '<div class="kicker">Seek ye wares above</div>';
      return;
    }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          wrap.innerHTML = '<p style="font-size:24px;font-style:italic;color:var(--steel-2)">No wares match “' +
            q + '”. Try “patch”, “sword”, or accepting defeat.</p>';
          return;
        }
        var cards = products.map(function (p) {
          var imgUrl = (p.featured_image && p.featured_image.url) || p.image || '';
          var pic = imgUrl
            ? '<div class="card-pic"><img src="' + imgUrl + '" alt="" loading="lazy"></div>'
            : '<div class="card-pic"><div class="ph"><span class="ph-lbl">' + p.title + '</span></div></div>';
          var price = typeof p.price === 'number' ? formatMoney(p.price) : (p.price || '');
          return '<a class="card" href="' + p.url + '">' + pic +
            '<div class="card-body"><div class="card-type">' + (p.type || '') + '</div>' +
            '<h3>' + p.title + '</h3>' +
            '<div class="card-foot"><span class="price">' + price + '</span>' +
            '<span class="quick">View →</span></div></div></a>';
        }).join('');
        wrap.innerHTML = '<div class="kicker" style="margin-bottom:18px">' + products.length +
          ' ware' + (products.length > 1 ? 's' : '') + ' found</div>' +
          '<div class="product-grid">' + cards + '</div>';
      })
      .catch(function () {
        wrap.innerHTML = '<p style="font-style:italic;color:var(--steel-2)">The search ravens are resting. Try the full search.</p>';
      });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (open) {
      var k = open.getAttribute('data-open');
      if (k === 'size') e.preventDefault();
      if (k === 'cart') { e.preventDefault(); openCart(); }
      else if (k === 'search') openSearch();
      else if (k === 'mobile') openMobile();
      else if (k === 'size') openSize();
      return;
    }
    if (e.target.closest('[data-close]')) { closeAll(); return; }
    if (e.target.closest('[data-scrim]')) { closeAll(); return; }
    if (e.target.closest('[data-checkout]')) { window.location.href = '/checkout'; return; }

    var line = e.target.closest('.cart-line');
    if (line) {
      var key = line.getAttribute('data-key');
      var input = $('[data-qty-input]', line);
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      if (e.target.closest('[data-qty-up]')) { changeLine(key, current + 1); return; }
      if (e.target.closest('[data-qty-down]')) { changeLine(key, Math.max(0, current - 1)); return; }
      if (e.target.closest('[data-remove]')) { changeLine(key, 0); return; }
    }

    var tab = e.target.closest('[data-size-tab]');
    if (tab) {
      var which = tab.getAttribute('data-size-tab');
      $all('[data-size-tab]').forEach(function (b) { b.classList.toggle('active', b === tab); });
      $all('[data-size-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-size-pane') !== which; });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var line = input.closest('.cart-line');
      changeLine(line.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  var searchInput = $('[data-search-input]');
  if (searchInput) {
    searchInput.addEventListener('input', function (e) {
      clearTimeout(searchTimer);
      var val = e.target.value;
      searchTimer = setTimeout(function () { runPredictive(val); }, 220);
    });
  }

  /* ---------- rotating announcement ---------- */
  (function () {
    var msgs = $all('[data-announce-msg]');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].style.opacity = 0;
      msgs[i].hidden = true;
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
      msgs[i].style.opacity = 0;
      requestAnimationFrame(function () { msgs[i].style.opacity = 1; });
    }, 4200);
  })();

  /* ---------- product add-to-cart forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form, form[data-product-form], form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return;
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; }
    addItem(idField.value, qty, function (err) {
      if (btn) btn.disabled = false;
      if (err) {
        var toast = $('[data-toast]');
        if (toast) { toast.textContent = err.description || 'Out of stock'; toast.classList.add('show'); setTimeout(function(){toast.classList.remove('show');}, 2200); }
        return;
      }
      var toast = $('[data-toast]');
      if (toast) { toast.textContent = '⚔ Added to thy satchel'; toast.classList.add('show'); setTimeout(function () { toast.classList.remove('show'); }, 2200); }
    });
  });

  /* expose for section scripts */
  window.TSG = {
    addItem: addItem,
    openCart: openCart,
    openSize: openSize,
    refreshCart: refreshCart,
    formatMoney: formatMoney,
    closeAll: closeAll
  };
})();
